import { Component, Input } from '@angular/core';

import { Store } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import { CreateService } from '@apps/its2/models/create-service';

import { CsStepsSummaryBaseComponent } from '../../common/cs-steps-summary-base.component';

@Component({
    selector: 'aa-cs-step3-summary',
    templateUrl: './cs-step3-summary.component.html',
    styleUrls: [
        '../../create-service-summary/create-service-summary.component.scss'
    ],
    standalone: false
})
export class CsStep3SummaryComponent extends CsStepsSummaryBaseComponent
{
    @Input() cs: CreateService;

    constructor (
        protected store: Store<IAuroraState>
    )
    {
        super(store);
    }
}
